import { ConvexReactClient } from "convex/react";

const configuredConvexUrl = import.meta.env.VITE_CONVEX_URL;
const localConvexUrl = import.meta.env.VITE_CONVEX_URL_LOCAL as
  | string
  | undefined;

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

const shouldForceLocal =
  import.meta.env.DEV &&
  isLocalHost &&
  typeof configuredConvexUrl === "string" &&
  configuredConvexUrl.includes(".convex.cloud") &&
  (import.meta.env.VITE_FORCE_LOCAL_CONVEX === "1" ||
    typeof localConvexUrl === "string");

const resolvedConvexUrl = shouldForceLocal
  ? (localConvexUrl as string)
  : configuredConvexUrl;

if (!resolvedConvexUrl) {
  throw new Error("Missing VITE_CONVEX_URL environment variable");
}

export const convex = new ConvexReactClient(resolvedConvexUrl, {
  verbose: import.meta.env.VITE_CONVEX_VERBOSE === "1",
});
